import { Charge, ChargeType } from 'interfaces';

// charges changing the pallets balance cannot be canceled
const notCancelableChargeTypes: ChargeType[] = ['LOST_PALLET', 'DAMAGE'];

export const isChargeCancelable: (charge: Charge) => boolean = charge =>
   !charge.hidden && !notCancelableChargeTypes.includes(charge.chargeType);
